import { Component, ChangeDetectorRef } from "@angular/core";
import * as moment from 'moment'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
    selector: "page-permisos",
    templateUrl: "./permisos.component.html",
    styleUrls: ["./permisos.component.css"],
    providers: [FormService]
})

export class PermisosComponent {

    public rows = [];
    public actualRow;
    public formulario;
    public valor;


    constructor(private _changeDetectionRef: ChangeDetectorRef) {

        this.formulario = new FormGroup({
            permiso_original: new FormControl(''),
            numero_original: new FormControl('', [Validators.pattern(/^[0-9]\d*$/)]),
            fecha_original: new FormControl(''),
            tipo_original: new FormControl(''),
            superficie_original: new FormControl(''),
        })


        if (!JSON.parse(localStorage.getItem("permiso_original"))) {
            localStorage.setItem("permiso_original", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("permiso_original"));
            this.formulario.controls['permiso_original'].setValue(this.rows[0] ? this.rows[0].permiso_original : '')
            this.formulario.controls['numero_original'].setValue(this.rows[0] ? this.rows[0].numero_original : '')
            this.formulario.controls['fecha_original'].setValue(new Date(this.rows[0] ? this.rows[0].fecha_original : ''))
            this.formulario.controls['tipo_original'].setValue(this.rows[0] ? this.rows[0].tipo_original : '')
            this.formulario.controls['superficie_original'].setValue(this.rows[0] ? this.rows[0].superficie_original : '')
        }

    }

    add_original() {


        localStorage.setItem("permiso_original", JSON.stringify([]));
        this.actualRow = localStorage.getItem("permiso_original");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            permiso_original: this.formulario.value.permiso_original,
            numero_original: this.formulario.value.numero_original,
            fecha_original: this.formulario.value.fecha_original ? moment(this.formulario.value.fecha_original).format('DD/MM/YYYY') : "",
            tipo_original: this.formulario.value.tipo_original,
            superficie_original: this.formulario.value.superficie_original,

        })
        localStorage.setItem("permiso_original", JSON.stringify(this.rows));


    }

}